<script>
export default {
    props: ['user']
}
</script>
<template>
    <div class="is-flex">
        <div class="mr-2">
            <b-icon size="is-small" icon="domain"/> <span class="detail-label">Firma:</span>
        </div>
        <div>
            <div v-if="user.role === 'employee'">
                <div v-for="company in (user?.companies || [])">
                    {{ company.name }}
                </div>
            </div>
            <span v-else> {{ user?.company.name }}</span>
        </div>
    </div>
</template>
